module.exports = __webpack_public_path__ + "025bfd96cf33ea92406dfa8805f533d9.jpg";